import _createForOfIteratorHelper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import Zt from "./base-device-parser.js";
import { Browsers as ri } from "./device-constants.js";

var ti = /*#__PURE__*/function (_Zt) {
  _inherits(ti, _Zt);

  var _super = _createSuper(ti);

  function ti() {
    var _this;

    _classCallCheck(this, ti);

    if (_this = _super.call(this), _this.userAgentData = navigator.userAgentData, _this.userAgentData) {
      var t = _this.sc();

      _this.browser = t.browser || "Unknown Browser", _this.version = t.version || "Unknown Version";
    }

    return _possibleConstructorReturn(_this);
  }

  _createClass(ti, [{
    key: "tf",
    value: function tf() {
      return this.browser;
    }
  }, {
    key: "ef",
    value: function ef() {
      return this.version;
    }
  }, {
    key: "Ko",
    value: function Ko(t) {
      var _this2 = this;

      if (this.OS) return Promise.resolve(this.OS);

      var r = function r(_r) {
        for (var s = 0; s < t.length; s++) {
          var e = ti.rf(_r, t[s]);
          if (e) return _this2.OS = e, _this2.OS;
        }

        return _r;
      };

      return this.userAgentData.platform ? Promise.resolve(r(this.userAgentData.platform)) : this.ic().then(function (t) {
        return r(t.platform);
      }).catch(function () {
        return navigator.platform;
      });
    }
  }, {
    key: "sc",
    value: function sc() {
      var t = {},
          r = this.userAgentData.brands;

      if (r && r.length) {
        var _iterator = _createForOfIteratorHelper(r),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var s = _step.value;

            var _r2 = this.nc(ri),
                e = s.brand.match(_r2);

            if (e && e.length > 0) {
              t.browser = e[0], t.version = s.version;
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return t;
    }
  }, {
    key: "nc",
    value: function nc(t) {
      var r = [];

      for (var s in t) {
        t[s] !== ri.yg && r.push(t[s]);
      }

      return new RegExp("(" + r.join("|") + ")", "i");
    }
  }, {
    key: "ic",
    value: function ic() {
      return this.userAgentData.getHighEntropyValues ? this.userAgentData.getHighEntropyValues(["platform"]) : Promise.reject();
    }
  }]);

  return ti;
}(Zt);

export { ti as default };